import { Link } from "react-router-dom";
import { Dot } from "lucide-react";
import BaseIntegrationIcon from "@reusables/BaseIntegrationIcon";

type ProductCodeProps = {
    code: string;
    supplierCode?: string | null;
    wrapCodeInLink?: boolean;
};

export default function ProductCode({
    code,
    supplierCode,
    wrapCodeInLink,
}: ProductCodeProps) {
    const codeElement = wrapCodeInLink ? (
        <Link to={`/dashboard/products/${code}/details/information`}>
            <u>{code}</u>
        </Link>
    ) : (
        <div className="text-sm text-accent">{code}</div>
    );

    return (
        <div className="flex flex-row gap-1">
            {codeElement}
            {supplierCode && (
                <div className="flex items-center gap-1">
                    <Dot className="w-4 h-4 text-accent" strokeWidth={3} />
                    <div className="flex items-center gap-1">
                        <BaseIntegrationIcon integration="twenty_four_seven_office" />
                        <span className="text-accent font-normal text-sm">
                            {supplierCode}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}
